// Angular
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Ionic
import {
  IonButton,
  IonContent,
  IonDatetime,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonList,
  IonModal,
  IonPopover,
  IonSearchbar,
  IonSelect,
  IonSelectOption,
  IonSpinner,
  IonToolbar,
  PopoverController
} from '@ionic/angular/standalone';

// Third party
import moment from 'moment';
import * as _ from 'lodash';
import { maskitoDateOptionsGenerator } from '@maskito/kit';
import { MaskitoOptions, MaskitoElementPredicate } from '@maskito/core';
import { MaskitoDirective } from '@maskito/angular';

// Local library
import { HORSE_BREED } from '@amwager/util-ts';
import { IReplays, WagerFacade } from '@amwager/wager/data-access';
import { DateFormatPipe, NumberWithCommasPipe } from '@amwager/util';



@Component({
  selector: 'feature-ion-replays-and-search',
  templateUrl: './replays-and-search.component.html',
  styleUrls: ['./replays-and-search.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonModal,
    IonContent,
    IonDatetime,
    IonInput,
    IonSelect,
    IonSelectOption,
    CommonModule,
    IonPopover,
    DateFormatPipe,
    NumberWithCommasPipe,
    MaskitoDirective,
    IonList,
    IonItem,
    IonSearchbar,
    IonToolbar,
    IonHeader,
    IonButton,
    IonIcon,
    IonSpinner
  ]
})
export class ReplaysAndSearchComponent implements OnInit {

  @ViewChild('popoverListRunner') popoverListRunnerRef!: any;
  @ViewChild('popoverInputRunner') popoverInputRunnerRef!: any;

  @ViewChild('popoverListHead') popoverListHeadRef!: any;
  @ViewChild('popoverInputHead') popoverInputHeadRef!: any;

  @ViewChild('inputRunnerName') inputRunnerNameRef!: any;


  HORSE_BREED = HORSE_BREED;

  getReplaysForm!: FormGroup;

  get formVal() { return this.getReplaysForm?.controls }

  replays?: any[];

  readonly dateOfBirthMask = maskitoDateOptionsGenerator({mode: 'mm/dd/yyyy', separator: '/'});
  readonly maskPredicate: MaskitoElementPredicate = async (el) => (
    el as HTMLIonInputElement
  ).getInputElement();

  getRunnersTimeout: any;
  presentPopoverComponent!: any;

  elementSelection: any;

  isAllowShowSelection = false;

  runnersName!: string[];
  headToHeadName!: string[];

  type!: 'runner' | 'head';

  isLoadingRunner = false;
  isLoadingHead = false;


  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly wagerFacade: WagerFacade,
    private readonly cdRef: ChangeDetectorRef,
    private readonly popoverController: PopoverController,
    private renderer: Renderer2,
  ) {
    document.addEventListener("click", (event) => {

      if (this.type === 'runner') this.runnersName = [];
      else this.headToHeadName = [];


      if (this.popoverListRunnerRef) {
        this.renderer.setStyle(
          this.popoverListRunnerRef?.el,
          'height',
          '0'
        );
      }

      if (this.popoverListHeadRef) {
        this.renderer.setStyle(
          this.popoverListHeadRef?.el,
          'height',
          '0'
        );
      }

      this.cdRef.markForCheck();
    });

    this.wagerFacade.getRunners$()
      .subscribe((runners) => {
        this.isLoadingRunner = false;
        this.isLoadingHead = false;

        if (!runners) return;

        if (this.type === 'runner') this.runnersName = runners || [];
        else this.headToHeadName = runners || [];

        if ((this.runnersName?.length !== 0) || (this.headToHeadName?.length !== 0)) {

          if (this.type === 'runner') {
            this.renderer.setStyle(
              this.popoverListRunnerRef?.el,
              'height',
              '225px'
            );

            this.renderer.setStyle(
              this.popoverListRunnerRef?.el,
              'width',
              this.inputRunnerNameRef?.el.offsetWidth + 'px'
            );
          }
          else {
            this.renderer.setStyle(
              this.popoverListHeadRef?.el,
              'height',
              '225px'
            );

            this.renderer.setStyle(
              this.popoverListHeadRef?.el,
              'width',
              this.inputRunnerNameRef?.el.offsetWidth + 'px'
            );
          }

        }

        this.cdRef.markForCheck();
      });
  }

  ngOnInit(): void {
    // update branch
    this.initForm();

    this.wagerFacade.getReplays$()
      .subscribe((replays?: IReplays) => {
        this.replays = [];

        replays = replays?.response?.AvailableVideos;

        _.flatMap(replays, (event) => {
          _.map(event, (item, breed) => {
            _.map(item, (data) => {
              this.replays = [
                ...this.replays || [],
                {
                  track: data?.EventName,
                  trackId: data?.TrackId,
                  date: data?.RaceDay,
                  breed,
                  race: data?.RaceId,
                  distance: data?.Distance,
                  surface: data?.Surface,
                  purse: data?.Purse
                }
              ];
            });
          });
        });

        // this.replays = _.sortBy(this.replays, ['date', 'race', 'track']);
        this.replays = _.orderBy(this.replays, ['date', 'race', 'track'], ['desc', 'asc', 'asc']);

        this.cdRef.markForCheck();
      });

    this.wagerFacade.getReplays(
      'ReplaysAndSearchComponent:ngOnInit',
      {
        raceDay: this.formVal['dateBy'].value,
        // remove moment format
        // replace
        // raceDay: moment(this.formVal['dateBy'].value).format("MM-DD-YYYY"),
        trackType: this.formVal['breed'].value,
        runnerName: this.formVal['runnerName'].value || '',
        runnerName2: this.formVal['headToHead'].value || '',
      }
    );
  }

  setDate(event: any): void {
    const value = event?.detail?.value;

    this.formVal['dateBy']?.setValue(moment(new Date(value)).format("MM/DD/YYYY"));

    this.search();
  }

  selectBreed(event: any): void {
    const value = event?.detail?.value;

    this.formVal['breed']?.setValue(value);

    this.search();
  }

  trackByFn(index: number, item: any): number {
    return item.id; // Use the unique ID property for tracking
  }

  private initForm(): void {
    this.getReplaysForm = this.formBuilder.group({
      dateBy: [moment(new Date()).format("MM/DD/YYYY"), [Validators.required]],
      breed: ['0', [Validators.required]],
      runnerName: [''],
      headToHead: ['']
    });
  }

  clear(): void {
    this.formVal['dateBy']?.setValue(moment(new Date()).format("MM/DD/YYYY"));
    this.formVal['breed']?.setValue('0');
    this.formVal['runnerName']?.setValue('');
    this.formVal['headToHead']?.setValue('');

    setTimeout(() => {
      this.wagerFacade.getReplays(
        'ReplaysAndSearchComponent:clear',
        {
          raceDay: moment(this.formVal['dateBy'].value).format("MM-DD-YYYY"),
          trackType: this.formVal['breed'].value,
          runnerName: this.formVal['runnerName'].value || '',
          runnerName2: this.formVal['headToHead'].value || '',
        }
      );
    }, 100);
  }

  search(key?: 'backspace' | 'keyup' | 'click'): void {
    setTimeout(() => {
      this.wagerFacade.getReplays(
        'ReplaysAndSearchComponent:search',
        {
          raceDay: moment(this.formVal['dateBy'].value).format("MM-DD-YYYY"),
          trackType: this.formVal['breed'].value,
          runnerName: this.formVal['runnerName'].value || '',
          runnerName2: this.formVal['headToHead'].value || '',
        }
      );
    }, 300);
  }

  getReplayVideo(replay: any): void {
    this.wagerFacade.getEventRaceVideoReplay(
      'ReplaysAndSearchComponent:getReplayVideo',
      {
        toteEventId: replay?.trackId,
        toteRaceId: replay?.race,
        raceDay: this.toDate(new Date(replay?.date), 2),
        width: 640,
        height: 500
      }
    );

    this.wagerFacade.setSelectedReplayInfo(
      replay?.track, replay?.date, replay?.breed, replay?.race
    );
  }

  toDate(date: Date, format: number = 1): string {
    const month = _.padStart(String(date.getMonth()+1), 2, '0');
    const day = _.padStart(String(date.getDate()), 2, '0');

    if(format == 2) return month + "-" + day + "-" + date.getFullYear();
    else return date.getFullYear() + "-" + month + "-" + day;
  }

  selectName(name: string, type: 'runner' | 'head'): void {
    if (type === 'runner') this.formVal['runnerName']?.setValue(name);
    else this.formVal['headToHead']?.setValue(name);

    this.search();
  }

  inputDate(event: any): void {
    const value = event?.target?.value;

    if (
      moment(new Date(this.formVal['dateBy'].value)).format("MM/DD/YYYY")
      === moment(new Date(value)).format("MM/DD/YYYY")
    ) return;

    this.formVal['dateBy']?.setValue(moment(new Date(value)).format("MM/DD/YYYY"));

    this.search();
  }

  searchName(type: 'runner' | 'head', event: any, status: string): void {
    this.type = type;

    const value = event?.target?.value;

    if (type === 'runner') this.formVal['runnerName']?.setValue(value);
    else this.formVal['headToHead']?.setValue(value);

    if (value?.length < 3) {

      if (type === 'runner') {
        this.isLoadingRunner = false;
        this.runnersName = [];
      }
      else {
        this.isLoadingHead = false;
        this.headToHeadName = []
      }

      if (type === 'runner' && this.popoverListRunnerRef) {
        this.renderer.setStyle(
          this.popoverListRunnerRef?.el,
          'height',
          '0'
        );
      }
      else if (type === 'head' && this.popoverListHeadRef) {
        this.renderer.setStyle(
          this.popoverListHeadRef?.el,
          'height',
          '0'
        );
      }
      return;
    }
    else {
      if (type === 'runner') this.isLoadingRunner = true;
      else this.isLoadingHead = true;

      if (this.getRunnersTimeout) clearTimeout(this.getRunnersTimeout);
      this.getRunnersTimeout = setTimeout(() => {

        if (type === 'runner') this.wagerFacade.getRunners(this.formVal['runnerName'].value);
        else this.wagerFacade.getRunners(this.formVal['headToHead'].value);
      }, 300);
    }

  }
}
